// extracted by mini-css-extract-plugin
export var dataCell = "_mi-2";
export var dataRow = "_mi-0";
export var headerRow = "_mi-1";